import { Circle, Heading, Stack, Text } from "@chakra-ui/react";

import { TrackEventProps } from "contexts/Tracking";
import { IconArrow } from "@ud/icons";
import CustomLink, { ILinkProps } from "components/Chakra/CustomLink";

type ICard = {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  price?: string;
  linkProps: ILinkProps;
  trackEventPayload: TrackEventProps;
};

const CardOption: React.FC<ICard> = ({
  title,
  description,
  icon,
  price,
  linkProps,
  trackEventPayload,
}) => (
  <CustomLink trackEventPayload={trackEventPayload} {...linkProps}>
    <Stack
      direction="column"
      align="center"
      borderRadius="6px"
      backgroundColor="ud-white"
      boxShadow="#C0C0C099 4px 0px 10px"
      p="24px"
      spacing="12px"
      h="100%"
    >
      <Stack direction="row" alignSelf="stretch" justifyContent="space-between">
        <Circle
          size="40px"
          bg="ud-white"
          alignItems="center"
          boxShadow="#C0C0C099 4px 0px 10px"
        >
          {icon}
        </Circle>
        <IconArrow boxSize="16px" fillWith="ud-primary" />
      </Stack>
      <Stack flex={1} justifyContent="space-between" w="100%">
        <Stack>
          <Heading
            as="h4"
            variant="h4"
            fontSize="22px"
            lineHeight="26px"
            color="ud-grey-600"
            fontWeight="600"
            textAlign={{ base: "left", md: "unset" }}
          >
            {title}
          </Heading>
          <Text
            fontSize="14px"
            lineHeight="18px"
            textAlign="left"
            m={0}
            color="ud-grey-600"
          >
            {description}
          </Text>
        </Stack>
        <Stack justifyContent="end" width="100%">
          <Text
            w="100%"
            fontSize="16px"
            lineHeight="22px"
            fontWeight="600"
            textAlign="left"
            color="ud-grey-600"
          >
            {price}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  </CustomLink>
);

export default CardOption;
